<template>
  <v-dialog v-model="dialog" max-width="700" persistent scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        rounded
        link
        color="teal"
        dark
        depressed
        small
        :block="isMobile()"
      >
        <v-icon left>mdi-help-circle-outline</v-icon>
        {{
          !isMobile()
            ? "Veja como consultar sua qualificação cadastral"
            : "Instruções"
        }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="teal--text font-weight-bold"
        >Consultar Qualificação Cadastral</v-card-title
      >
      <v-card-text class="black--text pt-3">
        <span>
          Para realizar a "Qualificação Cadastral", você deve ter em mãos seu
          CPF e PIS. Após isso, acesse pelo endereço:
          <a
            class="teal--text"
            href="http://consultacadastral.inss.gov.br/Esocial/pages/index.xhtml"
            target="_blank"
            >http://consultacadastral.inss.gov.br/Esocial/pages/index.xhtml</a
          ><span> ou pelo botão abaixo:</span></span
        >

        <v-btn
          target="_blank"
          to="http://consultacadastral.inss.gov.br/Esocial/pages/index.xhtml"
          class="mt-4"
          rounded
          block
          depressed
          color="teal"
          dark
          >Ir para o site <v-icon right>mdi-arrow-right</v-icon></v-btn
        >
        <ol class="mt-4" :style="{ 'line-height': '1.2rem' }">
          <li class="mb-4">Clique em “Consulta on-line”;</li>
          <li class="mb-4">
            Preencha os campos de “Nome, Data de Nascimento, CPF e NIS
            (NIT/PIS/PASEP)” e clique em “Adicionar”;
          </li>
          <li class="mb-4">Depois de adicionado clique em “Consultar”;</li>
          <li class="mb-4">
            Preencha os “caracteres de segurança” e clique novamente em
            “Consultar”;
          </li>
          <li class="mb-4">Qualificação realizada;</li>
          <li class="mb-4">
            Se a mensagem da sua qualificação for diferente de
            <b>“Os dados estão corretos”</b>, você deve seguir as orientações
            apresentadas e regularizar sua documentação o mais breve possível.
            Após regularizado, você deve realizar nova qualificação.
          </li>
        </ol>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded @click="dialog = false" text :block="isMobile()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>